import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    .partners-page-container {
      font-family: system-ui,-apple-system,roboto,'segoe ui',sans-serif;
    }

    .partners-page-header {
      padding: 1rem;
      border-bottom: 2rem solid var(--tenable-partners-header-border-color, #1E2426);
      margin-bottom: 5rem;
    }

    .partners-page-header li.list-inline-item {
      position: relative;
      list-style-type: none;
      height: 2em;
      margin-left: 3rem;
    }

    .partners-page-header li span {
      margin-right: 3rem;
    }

    .logo {
      margin-left: 3rem;
      width: 155px;
    }

    footer {
      color: #FFFFFF;
      margin-top: 10rem;
      padding-top: 3rem;
      padding-bottom: 5rem;
      background-color: var(--tenable-partners-footer-background-color, #1E2426);
    }

    .footer-content {
      text-align: center;
    }

    .footer-links a {
      color: #FFFFFF;

      &:hover {
        color: #FFFFFF;
      }
    }

    .footer-social a {
      width: 34px;
      height: 34px;

      &:hover {
        text-decoration: none;
      }
    }

    .hidden-container svg{
      display: none;
    }

    div.hidden-container {
      display: none;
    }

    .menu-link {
      position: relative;
    }

    .menu-link a {
      color: #1E2426;

      &:hover {
        color: #555555;
      }
    }

    .hidden-container a {
      color: #5B6062;
    }

    .menu-icon {
      position: absolute;
      bottom: -2.5rem;
      left: 50%;
      transform: translate(-50%);
    }

    .footer-social {
      display: block;
      margin-bottom: 1em;
    }

    .footer-social a {
      margin-right: 1em;
    }
  `,
];
